import { AppointmentPolicyType } from "@/constants/enum";
import { Merchant } from "@/dto/merchant";
import { DEPOSIT_TAKING_FOR_SERVICES_ENABLED } from "@/utils/constants";
import { useMerchantFeatureFlag } from "@/utils/useMerchantFeatureFlag";

export const useDepositPolicy = (
  merchant: Merchant,
  merchantPreferences: any
): boolean => {
  const depositEnabledFlag = useMerchantFeatureFlag(
    merchant,
    DEPOSIT_TAKING_FOR_SERVICES_ENABLED
  );
  const isDepositPolicy =
    merchantPreferences?.appointmentPref?.policyType ===
    AppointmentPolicyType.DEPOSIT;

  return merchant.isService && depositEnabledFlag && isDepositPolicy;
};
